import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ShiftAlertsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/work-schedule/_layout/alerts/')({
  validateSearch: zodValidator(ShiftAlertsSearchSchema)
});